import { createAction, props } from '@ngrx/store';

export const setCompany = createAction('Company', props<{ companyId: string }>());
